import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,{staticClass:"initial-layout"},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }